module.exports = __webpack_public_path__ + "static/media/everyday_digital_papers_with_guernsey.05cafe7d.png";